import { motion } from 'framer-motion';
import '../styles/sections.css';
import './FinalCTA.css';

export default function FinalCTA() {
  return (
    <section id="contact" className="section ctaSection">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="ctaTitle"
        >
          Verified, Audit-Ready Production System
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="ctaSubtitle"
        >
          Book a call with Gregory Kennedy and see how Keraunos turns AI from a
          cost sink hole into a token and cost efficient verified, audit-ready production system.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="ctaButtons"
        >
          <a href="mailto:office@keraunos-ai.com" className="btnPrimary">Contact</a>
        </motion.div>
      </div>
    </section>
  );
}
